import styled from "styled-components";

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 13px;
  border-top: 1px solid #e4e4e4;
  background: #3a3a3a;
  color: white;
  bottom: 0;
  @media (max-width: 420px) {
    text-align: center;
    flex-wrap: wrap;
    & .contact-us-msg {
      order: 1;
      flex: 0 1 100%;
      text-align: center;
      padding-bottom: 15px;
    }
    & :nth-child(1) {
      order: 2;
      margin-bottom: 7px;
    }
    & :nth-child(3) {
      order: 3;
    }
    .footer-item {
      flex-basis: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.style.js